import React from 'react'
import AdminDash from '../../Components/AdminComponents/AdminDash/AdminDash'
import ShowFeedback from '../../Components/Feedback/ShowFeedback'

function ViewFeedback() {
  return (
   <AdminDash>
       <ShowFeedback/>
   </AdminDash>
  )
}

export default ViewFeedback